import client from './client';
import { EnCryptData, DeCryptData } from '../util/CustomUtil';

// 로그인
export const login = ({ email, passwd }) => {
    // console.log("login Called !!!")
    let paramdata = { email, passwd };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/login', params);
}

// 회원 가입 
export const regist = ({ email, passwd, nickname, confirmData, isMkt }) => {
    let params = new URLSearchParams();
    // console.log("email : " + email + "," + passwd + ", nickname : " + nickname);
    let paramdata = { email, passwd, nickname, confirmData, isMkt }
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/reg', params);
}

// 가입 여부 확인 
export const checkid = ({ email, confirmData }) => {
    let params = new URLSearchParams();
    let paramdata = { email, confirmData }
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/check', params);
}

// 패스워드 변경 
export const changepw = ({ token, pw }) => {
    let params = new URLSearchParams();
    let paramdata = { token, pw }
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/reset', params);
}


// Mypage에서 패스워드 변경 
export const changeMypw = ({ token, pw, newpw }) => {
    let params = new URLSearchParams();
    let paramdata = { token, pw, newpw }
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/reset/mypw', params);
}

// 아이디 찾기 
export const findid = ({ confirmData }) => {
    // console.log("confirm data : " + JSON.stringify(confirmData))
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(confirmData)));
    return client.post('/user/findid', params);
}

// 로그아웃
export const logout = () => client.post('/api/auth/logout');

//좋아요 브랜드 리스트
export const brand = ({ email }) => {
    // console.log("getBrand")
    let paramdata = { email };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/brand', params);
}

//브랜드 오픈 요청 리스트
export const nobrand = ({ email }) => {
    // console.log("getNOBrand")
    let paramdata = { email };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/nobrand', params);
}

// 유저 정보 가져오기 
export const getUserInfo = () => client.get(`/user/info`);

// 마케팅 동의 가져오기 
export const getUserMrkt = () => client.get(`/user/info`);

// 마케팅 동의 업데이트 
export const setUserMrkt = ({ sms, email, kakao }) => {
    let params = new URLSearchParams();
    params.append('sms', sms);
    params.append('email', email);
    params.append('kakao', kakao);
    return client.post('/user/mrkt', params);
}

// 유저 정보 업데이트 
export const setUserInfoUpdate = ({ confirmData }) => {
    let paramdata = { confirmData };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/info', params);
}

// 유저 닉네임 정보 업데이트 
export const setUserNickInfoUpdate = ({ nickname }) => {
    let paramdata = { nickname };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/nickinfo', params);
}

// 유저 회원 탈퇴 정보 업데이트 
export const setUserDrop = ({ drop_reason, drop_reason_detail }) => {
    let paramdata = { drop_reason, drop_reason_detail };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/drop', params);
}

// Token Check 
export const checkRequest = () => client.get(`/user/checktoken`);

// get userclip info
export const getUserClip = ({ param }) => {
    return client.get('/user/clip?' + param);
}

// sync cart
export const syncCart = ({ syncCartItem }) => {
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(syncCartItem)));
    return client.post('/user/cart/sync', params);
}

// get cart
export const getCart = () => {
    return client.get('/user/cart');
}

//좋아요 상품 리스트
export const prod = ({ email }) => {
    let paramdata = { email };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/prod', params);
}
//마이페이지 좋아요 상품 리스트 가져오기 브랜드명 더보기
export const getUserClipProd = ({ email, brandid, offset, limit }) => {
    let paramdata = { email, brandid, offset, limit  };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/prodclip', params);
}

//좋아요 공간 리스트
export const space = ({ email }) => {
    let paramdata = { email };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/space', params);
}
//마이페이지 좋아요 공간 리스트 가져오기 더보기 포함
export const getUserClipSpace = ({ email, offset, limit }) => {
    let paramdata = { email, offset, limit };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/spaceclip', params);
}